
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, watch, reactive, onMounted, defineComponent} from 'vue';
import LoadingSpinner from "../loading/LoadingSpinner.vue";
import Select from "../form-elements/Select.vue";
import {
    convertInCurrency
} from "../../utils/utils";
// @ts-ignore
import Popper from 'vue3-popper/dist/popper.esm';

export default defineComponent({
    name: "TicketConfigurations",
    components: {
        LoadingSpinner,
        Select,
        Popper
    },
    props: {
        profilePersons: {
            type: Array,
            required: true,
        },
        ticketConfiguration: {
            type: Object,
            required: true,
        },
        selectedPriceConfiguration: {
            type: Object,
            required: true
        },
        selectedCurrency: {
            type: String,
            required: true
        }
    },
    emits: ['addPerson', 'removePerson'],
    setup(props, {emit}) {

        const availablePersons = ref(true);

        const pricePerPriceGroup = (priceGroup: String) => {
            return props.selectedPriceConfiguration.priceByPriceGroup ? props.selectedPriceConfiguration.priceByPriceGroup.filter((element) => element.id === priceGroup)[0] : {};
        }

        const personOptions = computed(() => {
            return props.profilePersons.map((person) => {
                return {
                    value: person.id,
                    label: person.name,
                    disabled: ticketPersons.value?.some((ticketPerson) => ticketPerson.value === person.id)
                }
            })
        });

        const getAvailablePersons = () => {
            return personOptions.value.some((personOption) => !personOption.disabled);
        };

        const personForm = reactive({
            selectedPerson: "",
        });

        const getInitialTicketPersons = () => {
            if (!props.ticketConfiguration['persons'] || Object.keys(props.ticketConfiguration['persons']).length === 0) {
                return [];
            } else {
                let tempArray = [];

                Object.keys(props.ticketConfiguration['persons']).map((personId) => {
                    if (props.ticketConfiguration['persons'][personId].counter !== 0) {
                        let obj = {
                            value: getPerson(personId).id,
                            label: getPerson(personId).name,
                            priceGroup: getPerson(personId).priceGroup
                        }
                        tempArray.push(obj);
                    }
                })

                return tempArray;
            }
        };

        const ticketPersons = reactive([]);

        onMounted(() => {
            ticketPersons.value = getInitialTicketPersons();
            availablePersons.value = getAvailablePersons();
        });

        watch(() => props.profilePersons, () => {
            availablePersons.value = getAvailablePersons();
        });

        const onAddPerson = () => {
            emit('addPerson', {
                id: personForm.selectedPerson,
                priceGroup: getPerson(personForm.selectedPerson).priceGroup,
                price: pricePerPriceGroup(getPerson(personForm.selectedPerson).priceGroup),
            });

            if(ticketPersons.value.some((ticketPerson) => ticketPerson.value === personForm.selectedPerson)) {
                return;
            }
            props.profilePersons.map((person) => {
                if(person.id === personForm.selectedPerson) {
                    let obj = {
                        value: person.id,
                        label: person.name,
                        priceGroup: person.priceGroup
                    }
                    ticketPersons.value.push(obj);
                }
            })

            availablePersons.value = getAvailablePersons();

            // track click on add person button
            window.dataLayer.push({
                'event': 'fellow_traveller_added',
            })
        };

        const onRemovePerson = (personId: string) => {
            emit('removePerson', personId);
            ticketPersons.value = ticketPersons.value.filter((person) => person.value !== personId);
            availablePersons.value = getAvailablePersons();
        };

        const getPerson = (id: string) => {
            return props.profilePersons.find((person) => person.id === id);
        };

        const getTotal = () => {
            let total = 0;

            if(ticketPersons.value?.length === 0) {
                return total;
            }
            ticketPersons.value?.map((person) => {
                total += pricePerPriceGroup(person.priceGroup).price;
            })

            return total;
        }

        return {
            translate,
            personOptions,
            personForm,
            ticketPersons,
            onAddPerson,
            onRemovePerson,
            convertInCurrency,
            pricePerPriceGroup,
            availablePersons,
            getTotal
        }
    }
})
